export default __webpack_public_path__ + "static/media/add-announcement-disabled.37b47e72.svg";